module.exports = __webpack_public_path__ + "img/logo.849132f5.jpg";